module.exports = __webpack_public_path__ + "static/media/5.e4b46fa2.jpg";